import { FC, useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { observer } from 'mobx-react-lite'
import { nanoid } from 'nanoid'

import { copyFindExcursionsStore } from 'entities/excursions/models/copy-find-excursions/copy-find-excursions-store'
import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'
import { listExcursionStore } from 'entities/excursions/models/list-excursions/list-excursions-state'

import { priceShow } from 'shared/lib/priceShow'
import { SearchResultBlock } from 'shared/ui/search-result-block'

import {
  PopularDirectionExcursions,
  popularDirectionExcursionsStore,
} from '../popular-directions'

import { Props } from './model'
import s from './styles.module.scss'

export const ListPopularDirection: FC<Props> = observer(() => {
  const directions = popularDirectionExcursionsStore.getPopularDirections()

  const [params] = useSearchParams()

  const isSearch = params.get('isSearch')

  const currentExcursionState = isSearch
    ? copyFindExcursionsStore
    : findExcursionsStore

  const { t } = useTranslation()

  const navigate = useNavigate()

  const onDetail = (direction: PopularDirectionExcursions) => {
    listExcursionStore.resetList()

    currentExcursionState.onSelectDirection({ direction_name: direction.name })

    navigate(-1)
  }

  const getListPopular = () => {
    popularDirectionExcursionsStore.fetchPopularDirections()
  }

  useEffect(() => {
    if (!directions?.length) {
      getListPopular()
    }
  }, [])

  return (
    <div className={s.container}>
      {directions?.map((direction) => (
        <SearchResultBlock
          isExcursions
          subTitle={direction?.name}
          image={direction?.image_url}
          title={`${t('from_price', { price: priceShow(String(direction?.price)) })}`}
          onSelect={() => onDetail(direction)}
          key={nanoid()}
        />
      ))}
    </div>
  )
})
